type HighlightAboutChatbotProp = {
    text : string
}
const HighlightAboutChatbot = ({text} : HighlightAboutChatbotProp) => {
  return (
    <span className="text-stroke4"> {text} </span>
  )
}

export default HighlightAboutChatbot